import { PermissionType } from '../PermissionType'

/** These permissions are necessary for an admin to be able to use the system */
export const minimalAdminUserPermissions = [
  PermissionType.GET_OWN_ORGANIZATION_CONFIGURATION,
  PermissionType.GET_OWN_ORGANIZATION,
  PermissionType.GET_OWN_ADMIN,
  PermissionType.GET_OWN_USER,
  PermissionType.GET_AUTOCOMPLETE_SUGGESTIONS,
  PermissionType.GET_REVERSE_GEOCODE,
  PermissionType.GET_PLACE_DETAILS,
]
